export const LOG_OUT_LISTENERS = new Set<(userInitiated: boolean) => unknown>();

let logOutSuppressed = false;

export function setLogOutSuppressed(suppressed: boolean) {
  logOutSuppressed = suppressed;
}

export function runLogOutSideEffects(userInitiated: boolean) {
  if (logOutSuppressed && !userInitiated) {
    return;
  }

  LOG_OUT_LISTENERS.forEach((listener) => listener(userInitiated));
}
